function formatPostalCode (postalCode) {
  if (!postalCode) return null;
  const chars = postalCode
    .split('')
    .filter(char => /\d/.test(char) || /[a-z]/i.test(char))
    .map(char => char.toUpperCase());

  return `${chars[0]}${chars[1]}${chars[2]}${chars[3]} ${chars[4]}${chars[5]}`;
}

module.exports = formatPostalCode;
